export var UserArgType;
(function (UserArgType) {
    UserArgType[UserArgType["Text"] = 0] = "Text";
    UserArgType[UserArgType["TextArea"] = 1] = "TextArea";
    UserArgType[UserArgType["Number"] = 2] = "Number";
    UserArgType[UserArgType["Color"] = 3] = "Color";
    UserArgType[UserArgType["Select"] = 4] = "Select";
    UserArgType[UserArgType["Range"] = 5] = "Range";
    UserArgType[UserArgType["Group"] = 6] = "Group";
    UserArgType[UserArgType["MoleculeInputParams"] = 7] = "MoleculeInputParams";
    UserArgType[UserArgType["Checkbox"] = 8] = "Checkbox";
    UserArgType[UserArgType["Vector3D"] = 9] = "Vector3D";
    UserArgType[UserArgType["Alert"] = 10] = "Alert";
    UserArgType[UserArgType["SelectRegion"] = 11] = "SelectRegion";
})(UserArgType || (UserArgType = {}));
